import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Video, Info } from "lucide-react";

interface VideoUrlInputProps {
  videoUrl: string | null;
  onVideoUrlChange: (value: string) => void;
}

export const VideoUrlInput: React.FC<VideoUrlInputProps> = ({
  videoUrl,
  onVideoUrlChange
}) => {
  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <Video className="h-4 w-4 text-[#00B6F0]" />
        <Label htmlFor="video-url" className="text-white font-medium">
          Vídeo da Página Pública
        </Label>
      </div>
      
      <div className="space-y-2">
        <Input
          id="video-url"
          type="url"
          value={videoUrl || ""}
          onChange={(e) => onVideoUrlChange(e.target.value)}
          placeholder="https://www.youtube.com/watch?v=..."
          className="bg-[#242C37] border-[#2A3749] text-white placeholder:text-gray-400"
        />
        
        <div className="flex items-start gap-2 text-xs text-gray-400">
          <Info className="h-3 w-3 mt-0.5 flex-shrink-0" />
          <p>
            Cole o link do YouTube que será exibido na sua página pública. 
            O vídeo aparecerá abaixo do botão "Falar com Mentor". 
            Deixe em branco se não quiser exibir vídeo.
          </p>
        </div>
      </div>
    </div>
  );
}; 